import { Component, ComponentType } from '@ecs/Component';

export class Entity {
  private static nextId = 1;
  public readonly id: number;
  private components: Map<string, Component> = new Map();
  private componentTypes: Set<string> = new Set();

  constructor() {
    this.id = Entity.nextId++;
  }

  addComponent<T extends Component>(component: T): this {
    const type = component.constructor.name;
    this.components.set(type, component);
    this.componentTypes.add(type);
    return this;
  }

  removeComponent<T extends Component>(ComponentClass: ComponentType<T>): this {
    const type = ComponentClass.name;
    this.components.delete(type);
    this.componentTypes.delete(type);
    return this;
  }

  getComponent<T extends Component>(ComponentClass: ComponentType<T>): T | undefined {
    return this.components.get(ComponentClass.name) as T | undefined;
  }

  hasComponent<T extends Component>(ComponentClass: ComponentType<T>): boolean {
    return this.componentTypes.has(ComponentClass.name);
  }

  hasComponents(...ComponentClasses: ComponentType<any>[]): boolean {
    return ComponentClasses.every(cc => this.componentTypes.has(cc.name));
  }

  getComponents(): Component[] {
    return Array.from(this.components.values());
  }
}